import React, { useState } from "react";
import { mediaUrl, initials } from "../../utils/media";

/**
 * Person avatar: the photo if there is one, otherwise a monogram of the name.
 * Sizing/shape come from the passed className (or the parent context), so the
 * same component fits a table cell, the top-nav chip, and the profile popover.
 */
const Avatar = ({ name, picture, className = "" }) => {
  const [failed, setFailed] = useState(false);
  const url = mediaUrl(picture);

  if (url && !failed) {
    return (
      <img
        className={className}
        src={url}
        alt={name || ""}
        onError={() => setFailed(true)}
      />
    );
  }

  return <span className={`${className} is-initials`.trim()}>{initials(name)}</span>;
};

export default Avatar;
